import { BOMTab, PNIDTab } from "./BOMTab";
import ECSTab from "./ECS";
// import MCSSCurve from "./SCurve";
// import PlantTasksWrapper from "../../../Project/plant/PlantTaskPage/PlantTasksWrapper";
import Schedule4D from "./Schedule4D";

export const getMCSTabs = (mrqList = []) => [
  {
    label: "Major Equipments",
    panel: <ECSTab />,
  },
  {
    label: "Valves & Instrumentation",
    panel: <PNIDTab />,
  },
  {
    label: "Bulk Materials",
    panel: <BOMTab />,
  },
  {
    label: "4D Schedule",
    // panel: <PlantTasksWrapper type={"procurement"} mrq={mrqList} />,
    panel: <Schedule4D />,
  },
];
